/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-thumbnail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * 14階建ハイグレード賃貸マンショングリーンスパーク109
 */
if (window.document.body.classList.contains("kusakidai-building-2") || window.document.body.classList.contains("town-hills-s")) {

  /**
   * Setting - Thumbnail Slider
   */
  const optionThumbail = {
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  };

  const sliderThumbnail = new Swiper(".slider__thumbnail", optionThumbail);


  /**
   * Setting - Main Slider
   */
  const optionMain = {
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: sliderThumbnail
    }
  };

  const sliderThumbnailMain = new Swiper(".slider__thumbnail__main", optionMain);
}